import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import { Modal, Popover, Tabs } from 'antd';
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import Pagination from "../../utils/Pagination";
import { formatDateToDMY, formatTime12Hour, formatEventType } from "../../utils/tools";
import ContentLoader from "../../utils/ContentLoader";
import { useState } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ImagePreviewModal from "../../utils/ImagePreviewModal";
import { getEventTypeTamil } from "../../utils/eventTypeUtils";
import Item from "antd/es/list/Item";

const { confirm } = Modal;

const ImageUploadTable = ({
      image,
      roles,
      page,
      setPage,
      totalPages,
      totalEntries,
      sort,
      order,
      setOrder,
      setSort,
      search,
      setSearch,
      onDelete,
      onView,
      activeTab,
      setActiveTab,
      fetchImages,
      entriesPerPage,
      setEntriesPerPage
}) => {
      const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
      const [loading, setLoading] = useState(false);
      const navigate = useNavigate();

      const headerConfig = [
            { key: "image", label: "Image", sortable: false },
            { key: "title", label: "Title", sortable: false },
            { key: "category", label: "Category", sortable: false },
            { key: "type", label: "Type", sortable: false },
            { key: "action", label: "Action", sortable: false }
      ];

      if (loading) return <ContentLoader />;

      return (
            <div className="card basic-data-table text-sm overflow-x-auto">
                  <div className="card-header responsive-header d-flex justify-content-end align-items-center global-header">


                        <div className="d-flex align-items-center gap-3">
                              {/* Refresh Icon */}
                              <Icon
                                    icon="mdi:refresh"
                                    width="26"
                                    height="26"
                                    className="ms-2 text-lg d-none d-md-inline-flex refresh-icon "
                                    onClick={fetchImages}
                              />

                              <div className="search-container" style={{ gap: "10px" }}>
                                    <SearchBy
                                          value={search}
                                          onChange={(e) => {
                                                setSearch(e.target.value);
                                                setPage(1);
                                          }}
                                    />
                                    {viewPermissions.includes("event.create") && (
                                          <button
                                                className="btn btn-primary-600 global-add-btn"
                                                type="button"
                                                onClick={() => navigate("/images-from")}
                                          >
                                                <Icon
                                                      icon="fa6-regular:square-plus"
                                                      className="icon text-lg line-height-1"
                                                />
                                                Add
                                          </button>
                                    )}
                              </div>
                        </div>
                  </div>
                  <div className="card-body card-body-modify">
                        <div className="w-full overflow-x-auto">
                              <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                                    <thead>
                                          <tr>
                                                {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                                          </tr>
                                    </thead>
                                    <tbody>
                                          {Array.isArray(image) && image.length > 0 ? (
                                                image.map((item) => (
                                                      <tr key={item.id}>
                                                            <td>
                                                                  <ImagePreviewModal src={item.url} thumbWidth={50}
                                                                        thumbHeight={50} />
                                                            </td>
                                                            <td>
                                                                  {item.title || "-"}
                                                            </td>
                                                            <td>
                                                                  {item.category || "-"}
                                                            </td>
                                                            <td>
                                                                  {getEventTypeTamil(item.type) || item.type || ""}
                                                            </td>
                                                            <td>
                                                                  <div className="d-flex align-items-center gap-8">
                                                                        <Popover
                                                                              trigger="click"
                                                                              placement="bottomRight"
                                                                              overlayClassName="action-popover"
                                                                              content={
                                                                                    <div className="action-list">
                                                                                          <button
                                                                                                onClick={() => navigate(`/images-from/${item.id}`)}
                                                                                                className="action-item text-success-main"
                                                                                          >
                                                                                                <Icon icon="lucide:edit" />
                                                                                                <span>Edit</span>
                                                                                          </button>
                                                                                          <button
                                                                                                className="action-item text-danger-main"
                                                                                                onClick={() => onDelete(item.id)}
                                                                                          >
                                                                                                <Icon icon="mingcute:delete-2-line" />
                                                                                                <span>Delete</span>
                                                                                          </button>
                                                                                    </div>
                                                                              }
                                                                        >
                                                                              <button
                                                                                    type="button"
                                                                                    className="w-32-px h-32-px bg-neutral-300 rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                                                                              >
                                                                                    <Icon icon="mdi:dots-vertical" />
                                                                              </button>
                                                                        </Popover>
                                                                  </div>
                                                            </td>
                                                      </tr>
                                                ))
                                          ) : (
                                                <tr>
                                                      <td colSpan={7} className="text-center">
                                                            No Image Found
                                                      </td>
                                                </tr>
                                          )}
                                    </tbody>
                              </table>
                        </div>
                        <Pagination
                              page={page}
                              setPage={setPage}
                              totalPages={totalPages}
                              totalEntries={totalEntries}
                              entriesPerPage={entriesPerPage}
                              setEntriesPerPage={setEntriesPerPage}
                        />
                  </div>
            </div>
      );
};

export default ImageUploadTable;